<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Sale Order</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="buyer_id">Buyer</label>
                                <div class="col-sm-6">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('buyer_id')}" :options="buyers"
                                            :selectLabel="''"
                                            @search-change="searchBuyer"
                                            class="form-control"
                                            data-vv-as="Supplier"
                                            id="buyer_id"
                                            label="org_name"
                                            name="buyer_id"
                                            open-direction="bottom"
                                            placeholder="Select Buyer"
                                            v-model="so.buyer"
                                            v-validate="'required'">
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('buyer_id')">{{ errors.first('buyer_id') }}</div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="so.buyer.currency_name">
                                <label class="col-sm-2 text-right control-label col-form-label" for="buyer_id">Buyer's Base Currency</label>
                                <div class="col-sm-6">
                                    <input :value="so.buyer.currency_name+' ('+so.buyer.currency_symbol+')'"
                                           class="form-control"
                                           readonly
                                           style="height: 42px;"
                                           type="text"
                                           v-if="currentOrg.currency_symbol">
                                </div>
                            </div>
                            <div class="form-group row" v-if="so.rows.length === 0">
                                <label class="col-md-2 text-right control-label col-form-label">Commodity</label>
                                <div class="col-md-4 mt-2">
                                    <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                       href="javascript:void(0)" v-if="so.rows.length === 0"><b>Click here to
                                        add commodity</b></a>
                                </div>
                            </div>
                            <div class="form-group row" v-for="(row, index) in so.rows">
                                <label class="col-sm-2 text-right control-label col-form-label" for="commodity_id">Commodity</label>
                                <div class="col-sm-2">
                                    <p id="commodity_id" class="form-control" style="height: 42px;">{{row.commodity.name}} <span
                                            v-if="row.commodity.code">({{row.commodity.code}})</span> -
                                        {{row.commodity.variety}}</p>
                                </div>
                                <div class="col-sm-2">
                                    <input :class="{'is-invalid': submitted && errors.has('quantity')}" class="form-control"
                                           data-vv-as="Quantity"
                                           id="quantity"
                                           name="quantity"
                                           placeholder="Quantity"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.quantity"
                                           v-validate="'numeric|min_value:1'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('quantity')">{{ errors.first('quantity') }}</div>
                                </div>
                                <div class="col-sm-2">
                                    <unit-select @unit-select="setUnit($event,index)"
                                                 data-vv-as="unit"
                                                 id="unit"
                                                 name="unit"
                                                 ref="reference"
                                                 v-model="row.unit_id">
                                    </unit-select>
                                    <div class="custom-invalid-feedback" v-if="submitted && !isUnitSelected">The Unit field is required.</div>
                                </div>
                                <div class="col-sm-2">
                                    <input :class="{'is-invalid': submitted && errors.has('rate')}" class="form-control"
                                           data-vv-as="Rate"
                                           id="rate"
                                           name="rate"
                                           placeholder="Rate"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.rate"
                                           v-validate="'decimal:3'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate')">{{ errors.first('rate') }}</div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group button-group">
                                        <button data-target="#searchAndSelectCommodityModal"
                                                data-toggle="modal" class="btn btn-success" type="button" v-if="so.rows.length === 1 || index === so.rows.length-1"><i class="fa fa-plus"></i></button>
                                        <button @click="removeRow(index)" class="btn btn-danger" type="button"><i class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                            <!--{{so}}-->
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds" @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import UnitSelect from "../../common/UnitSelect";
    import SearchSelectCommodity from "../../common/SearchSelectCommodity";

    export default {
        name: "SaleOrder",
        components: {SearchSelectCommodity, Multiselect, UnitSelect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                isUnitSelected: false,
                submitted: false,
                commodityIds: [],
                buyers: [],
                so: {
                    buyer: '',
                    rows: [
                    ]
                },
            };
        },
        mounted() {
            this.$refs.reference.unit = {
                "id": null,
                "name": null,
                "symbol": null,
            };
        },
        methods: {
            setUnit(e, i) {
                this.isUnitSelected     = true;
                this.so.rows[i].unit_id = e.id;
            },
            addRow() {
                this.so.rows.push({
                    commodity: '',
                    quantity: '',
                    unit_id: null,
                    rate: ''
                });
            },
            removeRow(index) {
                this.so.rows.splice(index, 1);
                this.commodityIds = this.so.rows.map(row => row.commodity.id);
            },
            async searchBuyer(searchText) {
                let reply = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                    params: {
                        search: searchText
                    }
                });

                this.buyers = reply.data;
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            async save() {
                try {
                    await this.$http.put('/marketplaces/' + this.currentOrg.marketplace_id + '/sales', this.so);
                    this.$router.push({name: "sales", params: {marketplaceid: this.currentOrg.marketplace_id}});
                    this.$toastr('success', 'Sale order added successfully.', 'Purchase Added');
                } catch(e) {
                    if(e.response.data.status === 404) {
                        this.$toastr('error', 'Commodity rate is not set, edit commodity and set rate', 'Failed');
                        this.$router.push({name: "commodities", params: {marketplaceid: this.currentOrg.marketplace_id}});
                    }
                }
            },
            setCommodity(e) {
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.so.rows.find(row=> row.commodity.commodity_id === c.id);
                    if(!found){
                        this.so.rows.push({
                            commodity: {
                                commodity_id: c.id,
                                commodity_name: c.name,
                                unit_id: c.unit ? c.unit.id : null,
                                unit_name: c.unit ? c.unit.name : null,
                                unit_symbol: c.unit ? c.unit.symbol : null,
                                ...c
                            },
                            unit_id: null,
                            rate: c.rate.amount,
                            quantity: null
                        })
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);

            }
        }
    }
</script>

<style scoped>
    .custom-invalid-feedback {
        display: block;
        width: 100%;
        margin-top: .25rem;
        font-size: 80%;
        color: #dc3545
    }
</style>
